import { SIGNUP_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import { Link } from "gatsby"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function HeroSection() {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("product-hero-illustration")
  return (
    <Container section>
      <SplitContainer
        className="mt-10 lg:-mt-10 lg:pb-16 lg:pt-20 xl:pb-32 xl:pt-40"
        image={illustration}
        imageSize="large"
        imageClassName="scale-150 md:scale-125 xl:scale-100 lg:translate-x-[7%] xl:translate-x-[10%] 2xl:translate-x-[5%] mt-[25%] md:mt-0 lg:mt-10"
      >
        <Heading
          level="h1"
          title="The open analytics platform for the modern data stack"
          subtitle={
            <>
              Preset Cloud is a fully-hosted, hassle-free cloud service for
              Apache Superset™. Get started for free today!
            </>
          }
          size="huge"
          narrow
        />
        <Button
          className="mt-7"
          color="green"
          size="medium"
          href={SIGNUP_URL}
          trackClick="Get started (hero)_Product"
          shadow
        >
          Get started
        </Button>
        <p className="mt-3 text-sm text-dark-grey">
          Need on-prem or private cloud?{" "}
          <Link to="/deploy-anywhere/" className="font-semibold text-lush">
            See all deployment models &rarr;
          </Link>
        </p>
      </SplitContainer>
    </Container>
  )
}

export default HeroSection
